import { createI18n } from 'vue-i18n'
import ptBR from '../locales/pt-BR.json'
import es from '../locales/es.json'
import en from '../locales/en.json'

export const LOCALE_STORAGE_KEY = 'backlog.locale'
export const DEFAULT_LOCALE = 'pt-BR'
export const SUPPORTED_LOCALES = ['pt-BR', 'es', 'en']

export function getStoredLocale() {
  try {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY)
    if (stored && SUPPORTED_LOCALES.includes(stored)) {
      return stored
    }
  } catch {
    /* ignore */
  }
  return DEFAULT_LOCALE
}

export function htmlLangForLocale(locale) {
  if (locale === 'pt-BR') return 'pt-BR'
  if (locale === 'es') return 'es'
  if (locale === 'en') return 'en'
  return DEFAULT_LOCALE
}

const initialLocale = getStoredLocale()

try {
  document.documentElement.lang = htmlLangForLocale(initialLocale)
} catch {
  /* ignore SSR / tests */
}

const i18n = createI18n({
  legacy: false,
  locale: initialLocale,
  fallbackLocale: DEFAULT_LOCALE,
  messages: {
    'pt-BR': ptBR,
    es,
    en
  }
})

try {
  document.title = i18n.global.t('app.documentTitle')
} catch {
  /* ignore SSR / tests */
}

export default i18n
